<template>
    <button
        class="miniBetSlip notranslate"
        type="button"
    >
        <span class="miniBetSlip-info">
            <span class="miniBetSlip-count" data-testid="mini-ticket-count">{{ hasWarning ? '!' : count }}</span>
            <span class="miniBetSlip-title" data-testid="mini-title">{{ title }}</span>
            <span
                v-if="odds"
                class="miniBetSlip-odds"
                data-testid="mini-total-odds"
            >@{{ odds }}</span>
        </span>
        <span class="miniBetSlip-maxPayout" data-testid="mini-total-max-payout">
            {{ maxPayout }}
        </span>
    </button>
</template>

<script setup lang="ts">
    withDefaults(defineProps<{
        count: number;
        title: string;
        odds?: string;
        maxPayout: string;
        hasWarning?: boolean;
    }>(), {
        odds: undefined,
        hasWarning: false,
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/miniBetSlip";
</style>
